import React from 'react';
import { StandardDialog } from '@roc/ui';
import { PayoffReconciliationReviewCategoryTable } from './payoffReconciliationReviewCategoryTable';
import { observer } from 'mobx-react';
import { Document } from '@roc/feature-types';
import { CustomTaskDialog } from '@roc/feature-general-tasks';

interface Props {
  open: boolean;
  onClose: () => void;
  document: Document;
  allowPayoffWaiverReview: boolean;
}

export const PayoffReconciliationReviewDialog = observer((props: Props) => {
  const { open, onClose, document, allowPayoffWaiverReview } = props;
  const taskId = document?.taskId;

  return (
    <>
      {taskId ? (
        <CustomTaskDialog
          open={open}
          title="Payoff Reconciliation Review"
          maxWidth="xl"
          handleClose={onClose}
          dialogContent={<PayoffReconciliationReviewCategoryTable allowPayoffWaiverReview={allowPayoffWaiverReview} />}
          taskId={taskId}
        />
      ) : (
        <div>
          <StandardDialog
            open={open}
            title="Payoff Reconciliation Review"
            maxWidth="xl"
            handleClose={onClose}
            dialogContent={<PayoffReconciliationReviewCategoryTable allowPayoffWaiverReview={allowPayoffWaiverReview} />}
          />
        </div >
      )}
    </>
  );
});